var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Header, Icon, Operators, StepContent } from './components';
import { useAppContext } from './contexts/AppContextProvider';
var App = function () {
    var _a = useAppContext(), activeStep = _a.activeStep, appConfig = _a.appConfig, menuOpen = _a.menuOpen, setMenuOpen = _a.setMenuOpen, handleActiveStep = _a.handleActiveStep;
    var toggleMenu = function () {
        var storedForm = localStorage.getItem('activeStep');
        if (!menuOpen) {
            handleActiveStep(storedForm || 'navigation');
        }
        setMenuOpen(!menuOpen);
    };
    var handleOutsideClick = function (event) {
        var target = event.target;
        if (!target.closest('.chat-app-container') && !target.closest('.icon-container')) {
            setMenuOpen(false);
        }
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleOutsideClick);
        return function () {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    return (_jsxs("div", __assign({ className: "okay-chat-app" }, { children: [_jsx(Icon, { toggleMenu: toggleMenu }), _jsx("div", __assign({ className: "chat-app-container ".concat(menuOpen ? 'open' : '') }, { children: menuOpen && (_jsxs(_Fragment, { children: [_jsx(Header, { title: appConfig.headerText }), _jsx(Operators, {}), _jsx(StepContent, { step: activeStep })] })) }))] })));
};
export default App;
